import React from "react";
import { ProductsSlider } from "../../../../../components/ProductsSlider/ProductsSlider";
import MainPageProduct from "../MainPageProduct";
import { ImageType, Product, ProductImageTypes, ProductShelvesSection } from "@core/types";
import cx from "classnames";
import ProductShelfSkeleton from "./ProductShelfSkeleton";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../../../../providers/config";
import { IonIcon } from "@ionic/react";
import { chevronForward } from "ionicons/icons";

type ProductShelfProps = {
  titleClassName?: string;
  isLoading?: boolean;
  className?: string;
  classnameSkeleton?: string;
  showCategoryButton?: boolean;
  categoryName?: string;
  onCategoryClick?: () => void;
} & Partial<ProductShelvesSection>;

const ProductShelf = ({
  id,
  title = "",
  isLoading,
  titleClassName,
  className,
  images,
  items: products = [],
  classnameSkeleton,
  showCategoryButton = false,
  categoryName,
  onCategoryClick,
  ...props
}: ProductShelfProps) => {
  const { t } = useTranslation();
  const config = useConfig();
  const history = useHistory();
  const firstImage = images?.[0] ? ({ ...images[0], type: ProductImageTypes.img } as ImageType) : undefined;
  const haveImage = !!firstImage;

  const visibleProducts = products.slice(0, config.maxVisibleProductsOnHome!);

  const showShopMore = id && products.length > 8!;

  const renderItem = (product: Product) => {
    return <MainPageProduct product={{ ...product, parentName: product.name }} lazyload={false} />;
  };

  const handleToShowAll = () => {
    history.push(`/product-shelf/${id}`);
  };

  if (isLoading) {
    return <ProductShelfSkeleton haveImage={haveImage} classnameSkeleton={classnameSkeleton} />;
  }

  if (!products?.length) return null;

  return (
    <div className={cx("flex flex-col gap-2.5", className)}>
      <div className={cx("flex items-center justify-between", showShopMore && !title.length && "!justify-end")}>
        {title && <h1 className={cx(titleClassName)}>{title}</h1>}
        {showCategoryButton && (
          <span onClick={onCategoryClick} className="text-sm font-semibold text-black cursor-pointer flex items-center">
            {categoryName}
            <IonIcon icon={chevronForward} className="text-base" />
          </span>
        )}
        {showShopMore && (
          <button onClick={handleToShowAll} className="text-sm font-semibold underline text-primary">
            {t("Shop More")}
          </button>
        )}
      </div>

      <div>
        <ProductsSlider
          firstImage={firstImage}
          items={visibleProducts}
          onImageClick={handleToShowAll}
          haveImage={haveImage}
          renderItem={renderItem}
          containerClassName="!px-0 !pb-0 w-full"
        />
      </div>
    </div>
  );
};

export default ProductShelf;
